import _ from 'lodash'
import React from 'react'
import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'

export const FI = LanguageCode.FI
export const SV = LanguageCode.SV
export const EN = LanguageCode.EN
export const AF = LanguageCode.AF

export const LANGUAGES = [
  { code: FI, label: 'FI' },
  { code: SV, label: 'SVE' },
  { code: EN, label: 'EN' },
  { code: AF, label: 'TRANSIFEX' },
]

export const SUPPORTED_LANGUAGES = LANGUAGES.map((lang) => lang.code)

export function isAvailableLanguage(lang) {
  return SUPPORTED_LANGUAGES.includes(lang)
}

export function init(lang, ...bundles) {
  if (!_.isString(lang)) {
    throw new Error(`requested lang must be a string, was ${typeof lang}`)
  }
  if (!isAvailableLanguage(lang)) {
    throw new Error(`requested lang is not supported: '${lang}'`)
  }
  const mergedBundle = _.reduce(
    bundles,
    (memo, bundle) => {
      _.keys(bundle).forEach((key) => {
        if (_.has(memo, key)) {
          throw new Error(`duplicate key found: ${key}`)
        }
      })
      return _.merge({}, memo, bundle)
    },
    {}
  )
  return initTranslation(lang, mergedBundle)
}

function initTranslation(lang, bundle) {
  return function translate(key) {
    const entry = bundle[key]
    if (entry) {
      const translation = entry[lang]
      if (translation) {
        if (
          !React.isValidElement(translation) ||
          !Array.isArray(translation.props.children)
        ) {
          return translation
        }
        return reactChildrenWithUniqueKeys(translation)
      } else if (entry[FI]) {
        console.warn(
          `translation not found by key '${key}' for lang '${lang}', using default lang '${FI}'`
        )
        return entry[FI]
      } else {
        throw new Error(
          `translation by key '${key}' does not exist for lang '${lang}', entry: ${JSON.stringify(
            entry
          )}`
        )
      }
    } else if (key === '') {
      return ''
    } else {
      throw new Error(`translation by key '${key}' does not exist`)
    }
  }
}

// Changes `moment` lang in browser. Is noop on server because as of writing affects only a calendar opened by user.
/*
export function changeLang(requestedLang) {
  if (isInsideBrowser()) {
    const newLang = normalizeLang(requestedLang)
    moment.locale(newLang)
  }
}
*/

export function normalizeLang(requestedLang) {
  return isAvailableLanguage(requestedLang) ? requestedLang : FI
}

export function normalizeSupportedLang(supportedLanguages, requestedLang) {
  return _.includes(supportedLanguages, requestedLang) ? requestedLang : FI
}

// Adds a unique React key for JSX child elements
function reactChildrenWithUniqueKeys(translation) {
  const generateChildElementsWithUniqueKeys = (parentElement) => {
    parentElement.props.children = parentElement.props.children.map(
      (childElement, index) => {
        if (React.isValidElement(childElement)) {
          childElement.key = index
          if (Array.isArray(childElement.props.children)) {
            return generateChildElementsWithUniqueKeys(childElement)
          }
        }
        return childElement
      }
    )
    return parentElement
  }
  return generateChildElementsWithUniqueKeys(translation)
}

export function urlWithoutLang(url, search) {
  const pathParts = url.split('/')
  const lang = pathParts[1]
  if (lang && normalizeLang(lang) === lang) {
    return '/' + buildUrl(_.drop(pathParts, 2).join('/'), search)
  } else {
    return buildUrl(url, search)
  }
}

function buildUrl(url, search) {
  return search ? `${url}?${search.replace(/^\?/, '')}` : url
}
